export default {
  "AC": {
    "default": "AC",
    "br": "BR-AC",
    "number": "01",
    "uf": 12
  },
  "AL": {
    "default": "AL",
    "br": "BR-AL",
    "number": "02",
    "uf": 27
  },
  "AP": {
    "default": "AP",
    "br": "BR-AP",
    "number": "03",
    "uf": 16
  },
  "AM": {
    "default": "AM",
    "br": "BR-AM",
    "number": "04",
    "uf": 13
  },
  "BA": {
    "default": "BA",
    "br": "BR-BA",
    "number": "05",
    "uf": 29
  },
  "CE": {
    "default": "CE",
    "br": "BR-CE",
    "number": "06",
    "uf": 23
  },
  "DF": {
    "default": "DF",
    "br": "BR-DF",
    "number": "27",
    "uf": 53
  },
  "ES": {
    "default": "ES",
    "br": "BR-ES",
    "number": "07",
    "uf": 32
  },
  "GO": {
    "default": "GO",
    "br": "BR-GO",
    "number": "08",
    "uf": 52
  },
  "MA": {
    "default": "MA",
    "br": "BR-MA",
    "number": "09",
    "uf": 21
  },
  "MT": {
    "default": "MT",
    "br": "BR-MT",
    "number": "10",
    "uf": 51
  },
  "MS": {
    "default": "MS",
    "br": "BR-MS",
    "number": "11",
    "uf": 50
  },
  "MG": {
    "default": "MG",
    "br": "BR-MG",
    "number": "12",
    "uf": 31
  },
  "PA": {
    "default": "PA",
    "br": "BR-PA",
    "number": "13",
    "uf": 15
  },
  "PB": {
    "default": "PB",
    "br": "BR-PB",
    "number": "14",
    "uf": 25
  },
  "PR": {
    "default": "PR",
    "br": "BR-PR",
    "number": "15",
    "uf": 41
  },
  "PE": {
    "default": "PE",
    "br": "BR-PE",
    "number": "16",
    "uf": 26
  },
  "PI": {
    "default": "PI",
    "br": "BR-PI",
    "number": "17",
    "uf": 22
  },
  "RJ": {
    "default": "RJ",
    "br": "BR-RJ",
    "number": "18",
    "uf": 33
  },
  "RN": {
    "default": "RN",
    "br": "BR-RN",
    "number": "19",
    "uf": 24
  },
  "RS": {
    "default": "RS",
    "br": "BR-RS",
    "number": "20",
    "uf": 43
  },
  "RO": {
    "default": "RO",
    "br": "BR-RO",
    "number": "21",
    "uf": 11
  },
  "RR": {
    "default": "RR",
    "br": "BR-RR",
    "number": "22",
    "uf": 14
  },
  "SC": {
    "default": "SC",
    "br": "BR-SC",
    "number": "23",
    "uf": 42
  },
  "SP": {
    "default": "SP",
    "br": "BR-SP",
    "number": "24",
    "uf": 35
  },
  "SE": {
    "default": "SE",
    "br": "BR-SE",
    "number": "25",
    "uf": 28
  },
  "TO": {
    "default": "TO",
    "br": "BR-TO",
    "number": "26",
    "uf": 17
  }
};